import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/common/Layout';
import Home from './pages/Home';
import About from './pages/About';
import UseCases from './pages/UseCases';
import Products from './pages/Products';
import Solutions from './pages/Solutions';
import Demo from './pages/Demo';
import Estimate from './pages/Estimate';
import Contact from './pages/Contact';
import Support from './pages/Support';

import { AuthProvider } from './context/AuthContext';
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import InquiryList from './pages/admin/InquiryList';
import ProposalDetail from './pages/admin/ProposalDetail';
import CaseManagement from './pages/admin/CaseManagement';
import CaseEditor from './pages/admin/CaseEditor';
import ProductManagement from './pages/admin/ProductManagement';
import SolutionManagement from './pages/admin/SolutionManagement';
import SolutionEditor from './pages/admin/SolutionEditor';
import PopupManagement from './pages/admin/PopupManagement';

import PresetManagement from './pages/admin/PresetManagement';
import UserManagement from './pages/admin/UserManagement';
import ContentReview from './pages/admin/ContentReview';
import ContentReviewEditor from './pages/admin/ContentReviewEditor';
import VersionList from './pages/admin/auto-estimate/VersionList';
import EstimateDetail from './pages/admin/auto-estimate/EstimateDetail';
import AnalyticsDashboard from './pages/admin/auto-estimate/AnalyticsDashboard';
import PrivateRoute from './components/auth/PrivateRoute';
import GlobalLoginModal from './components/auth/GlobalLoginModal';

import PageTracker from './components/common/PageTracker';
import ScrollManager from './components/common/ScrollManager';
import FloatingCTA from './components/features/FloatingCTA';

import Privacy from './pages/Legal/Privacy';
import Terms from './pages/Legal/Terms';

import SolutionDetail from './pages/Solutions/SolutionDetail';
import Notes from './pages/Notes';
import NotesSegment from './pages/Notes/NotesSegment';
import Partners from './pages/Partners';
import PartnerManagement from './pages/admin/PartnerManagement';

function App() {
  return (
    <AuthProvider>
      <GlobalLoginModal />
      <Router>
        <PageTracker />
        <ScrollManager />
        <FloatingCTA />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/use-cases" element={<Layout><UseCases /></Layout>} />
          <Route path="/use-cases/:id" element={<Layout><UseCases /></Layout>} />
          <Route path="/products" element={<Layout><Products /></Layout>} />
          <Route path="/products/:id" element={<Layout><Products /></Layout>} />
          <Route path="/solutions" element={<Layout><Solutions /></Layout>} />
          {/*
            정본 경로는 `/solutions/{대표코드}/{slug}` 2단이다 (설계 03 §2-6).
            한 단짜리 `/solutions/{코드}` 는 업종 허브다. 구 주소 `/solutions/{숫자}` 로
            **직접 들어온 요청은 nginx→NestJS 가 실제 301 을 내므로 여기까지 오지 않는다.**
            여기 오는 건 앱 내부 이동뿐이라 허브가 받아서 처리한다.
          */}
          <Route path="/solutions/:category" element={<Layout><Solutions /></Layout>} />
          <Route path="/solutions/:category/:slug" element={<Layout><SolutionDetail /></Layout>} />
          <Route path="/partners" element={<Layout><Partners /></Layout>} />
          {/*
            기술노트는 **평면** `/notes/{slug}` 다 (설계 03 §2-2 — 솔루션의 2단과 의도적으로 다르다).
            카테고리 허브 `/notes/{코드}` 와 모양이 같아서, 어느 쪽인지는 카테고리 목록에
            있는 slug 인지로 NotesSegment 가 가른다.
          */}
          <Route path="/notes" element={<Layout><Notes /></Layout>} />
          <Route path="/notes/:segment" element={<Layout><NotesSegment /></Layout>} />
          <Route path="/demo" element={<Layout><Demo /></Layout>} />
          <Route path="/estimate" element={<Layout><Estimate /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/support" element={<Layout><Support /></Layout>} />
          <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
          <Route path="/terms" element={<Layout><Terms /></Layout>} />
          {/*
            '업데이트' 페이지는 지웠다(2026-10) — 관리하는 곳 없이 예시 공지 2건이 박혀 있었다.
            예전 링크로 들어오면 빈 화면 대신 메인으로 보낸다.
          */}
          <Route path="/updates" element={<Navigate to="/" replace />} />
          <Route path="/support/*" element={<Layout><Support /></Layout>} />
          {/* Admin Routes */}
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<PrivateRoute />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="inquiries" element={<InquiryList />} />
            <Route path="proposals/:id" element={<ProposalDetail />} />
            <Route path="cases" element={<CaseManagement />} />
            <Route path="cases/new" element={<CaseEditor />} />
            <Route path="cases/:id" element={<CaseEditor />} />
            <Route path="products" element={<ProductManagement />} />
            <Route path="solutions" element={<SolutionManagement />} />
            <Route path="solutions/new" element={<SolutionEditor />} />
            <Route path="solutions/:id" element={<SolutionEditor />} />
            <Route path="partners" element={<PartnerManagement />} />
            <Route path="popups" element={<PopupManagement />} />
            <Route path="presets" element={<PresetManagement />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="contents" element={<ContentReview />} />
            <Route path="contents/:id" element={<ContentReviewEditor />} />
            <Route path="auto-estimate" element={<VersionList />} />
            <Route path="auto-estimate/analytics" element={<AnalyticsDashboard />} />
            <Route path="auto-estimate/:versionId" element={<EstimateDetail />} />
          </Route>

        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
